export default __webpack_public_path__ + "static/media/example.84cfc491.png";